<template>
  <div>
    {{hourText}}:{{minuteText}}:{{secondText}}
  </div>
</template>
<script>
//倒计时组件
export default {
  props:{
    secTime:{
      type:Number,
      require:true
    }
  },
  data() {
    return {
      hourText:"00",
      minuteText:"00",
      secondText:"00",
      intervalTimer:"",
    }
  },
  created() {
    this.countdown();
  },
  methods: {
    countdown () {
      let sec =this.secTime;
      const that = this;

      let hour = 0
      let minute = 0
      let second = 0
      that.intervalTimer = setInterval(function () {
        if (sec >= 60) {
          minute = Math.floor(sec / 60)
          second = sec % 60
          if (minute >= 60) {
            hour = Math.floor(minute / 60)
            minute = minute % 60
          } else {
                hour = 0
              }
        } else {
          second = sec
          hour = 0
          minute = 0
        }

        hour = hour < 10 && hour > 0 || hour === 0 ? '0' + hour : hour
        minute = minute < 10 && minute > 0 || minute === 0 ? '0' + minute : minute
        second = second < 10 && second > 0  || second === 0  ? '0' + second : second
        that.hourText = hour;
        that.minuteText = minute;
        that.secondText = second;
        sec--
        if (sec <= 0) {
          that.hourText = "00";
          that.minuteText = "00";
          that.secondText = "00";
          //清除定时器 执行回掉
          clearInterval(that.intervalTimer);
          that.$emit("timeOn");
        }
      }, 1000)
    }
  },
  beforeDestroy() {
    //清除定时器
    clearInterval(this.intervalTimer);
  },
}
</script>



// WEBPACK FOOTER //
// countdown.vue?796bb430